import { Button, Col, Form, Input, Row } from "antd";
import { useEffect } from "react";
import dayjs from "dayjs";
import CustomDateTimePicker from "../../../global/components/inputWidgets/CustomDatePicker";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { HiArrowPath } from "react-icons/hi2";

export const AuditLogFilter = ({
  filter,
  handleFilterChange,
  handleFilter,
  handleReset,
  setFilter,
  params,
}) => {
  const [form] = Form.useForm();
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {};

  const handleFormChange = (changedValues) => {
    if ("AuditTime" in changedValues) {
      setFilter((prev) => ({
        ...prev,
        AuditTime: changedValues.AuditTime,
      }));
    }
  };

  useEffect(() => {
    const t = params?.get("AuditTime");
    if (t) form.setFieldsValue({ AuditTime: dayjs.unix(Number(t)) });
    else form.setFieldsValue({ AuditTime: undefined });
  }, [params, form]);

  useEffect(() => {
    if (modParams?.AuditTime) {
      form.setFieldsValue({
        AuditTime: dayjs.unix(Number(modParams.AuditTime)),
      });
    }
  }, []);

  return (
    <Form form={form} className="mb-4" onValuesChange={handleFormChange}>
      <div className="mt-2">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
            <Input
              className="input_text_3 mr10 h-full"
              placeholder="No"
              name="AuditNo"
              value={filter.AuditNo}
              onChange={(e) => {
                const { value } = e.target;
                if (/^\d*$/.test(value)) {
                  handleFilterChange(e);
                }
              }}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
            <CustomDateTimePicker
              name="AuditTime"
              placeholder="Audit Time"
              format="YYYY-MM-DD HH:mm"
              showTime={{ format: "HH:mm" }}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
            <Input
              className="input_text_3 mr10 h-full"
              placeholder="Account"
              name="AccountUserId"
              value={filter.AccountUserId}
              onChange={handleFilterChange}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
            <Input
              className="input_text_3 mr10 h-full"
              placeholder="Description"
              name="Description"
              value={filter.Description}
              onChange={handleFilterChange}
            />
          </Col>
        </Row>
      </div>

      <div className="flex justify-between my-4 overflow-x-auto !items-center">
        <div className="flex items-center">
          <Button
            type="primary"
            className="mr-2 w-[104px] h-[30px] font-medium"
            onClick={handleFilter}
          >
            <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
            Apply
          </Button>
          <Button
            className="reset-button"
            onClick={() => {
              form.resetFields();
              handleReset();
            }}
          >
            <HiArrowPath className="!text-[14px] font-medium" />
            Reset
          </Button>
        </div>
      </div>
    </Form>
  );
};
